import {useEffect, useState} from "react";
import {
    createInstance as createInstanceRequest,
    deleteInstance as deleteInstanceRequest,
    editInstance as editInstanceRequest,
    getInstancesByVendor,
    logoutInstance as logoutInstanceRequest,
    rebootInstance as rebootInstanceRequest,
    updateAllInstancesStatus,
    updateInstanceStatus as updateInstanceStatusRequest,
} from "../../../services/greenApi";

const emptyNewInstance = {
    phone: '',
    name: '',
    queue: '',
    minPauseMessage: '5',
    maxPauseMessage: '10',
    apiTokenInstance: '',
    instanceId: '',
    host: '',
    mediaHost: '',
};

export default function useVendorInstances(vendor) {
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
    const [rowData, setRowData] = useState({});
    const [originalRowData, setOriginalRowData] = useState({});
    const [errorDialog, setErrorDialog] = useState(false);
    const [successDialog, setSuccessDialog] = useState(false);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const [refreshTable, setRefreshTable] = useState(false);
    const [isOpenDeleteInstanceDialog, setIsOpenDeleteInstanceDialog] = useState(false);
    const [newInstance, setNewInstance] = useState(emptyNewInstance);
    const [disableBtn, setDisableBtn] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (newInstance.phone.length && newInstance.name.length && newInstance.instanceId.length &&
            newInstance.queue.length && newInstance.minPauseMessage.length &&
            newInstance.maxPauseMessage.length && newInstance.apiTokenInstance.length &&
            newInstance.host.length && newInstance.mediaHost.length) {
            setDisableBtn(false);
        } else {
            setDisableBtn(true);
        }
    }, [newInstance]);

    const errorOccurred = (message) => {
        setErrorDialog(true);
        setErrorMessage(message);
        setTimeout(() => {
            setErrorDialog(false);
            setErrorMessage('');
        }, 2000);
    };

    const successResponse = () => {
        setSuccessDialog(true);
        setTimeout(() => {
            setSuccessDialog(false);
        }, 2000);
    };

    const getTableData = (page, per_page, order, order_by) => {
        return getInstancesByVendor(vendor, page, per_page, order, order_by);
    };

    const openMenuDialog = (row) => {
        setRowData(row);
        setOriginalRowData(row);
        setIsOpen(!isOpen);
    };

    const handleCloseEditDialog = () => {
        setIsOpenEditDialog(!isOpenEditDialog);
        setRowData(originalRowData);
    };

    const deleteInstanceDialog = () => {
        setIsOpenDeleteInstanceDialog(!isOpenDeleteInstanceDialog);
    };

    const applyRowResponse = (data) => {
        const currentRow = data.data.find(item => item.id === rowData.id);
        setRowData(currentRow);
        successResponse();
        setRefreshTable(prev => !prev);
    };

    const updateStatus = () => {
        updateInstanceStatusRequest(rowData.id).then((data) => {
            if (data.success) {
                applyRowResponse(data);
            } else {
                errorOccurred(data.error.message);
            }
        });
    };

    const restartInstance = () => {
        rebootInstanceRequest(rowData.id).then((data) => {
            if (data.success) {
                applyRowResponse(data);
            } else {
                errorOccurred(data.error.message);
            }
        });
    };

    const logoutInstance = () => {
        logoutInstanceRequest(rowData.id).then((data) => {
            if (data.success) {
                applyRowResponse(data);
            } else {
                errorOccurred(data.error.message);
            }
        });
    };

    const deleteInstance = () => {
        deleteInstanceRequest(rowData.id).then((data) => {
            if (data.success) {
                setIsOpen(false);
                deleteInstanceDialog();
                successResponse();
                setRefreshTable(prev => !prev);
            } else {
                errorOccurred(data.error.message);
            }
        });
    };

    const editInstance = () => {
        const payload = {
            host: rowData.host ?? null,
            mediaHost: rowData.mediaHost ?? null,
            phoneNumber: rowData.phone ?? null,
            name: rowData.name ?? null,
            queue: rowData.queue ?? null,
            minPauseMessage: Number(rowData.minPauseMessage) ?? null,
            maxPauseMessage: Number(rowData.maxPauseMessage) ?? null,
            instanceId: rowData.instanceId ?? null,
            apiTokenInstance: rowData.apiTokenInstance ?? null,
        };

        editInstanceRequest(rowData.id, payload).then((data) => {
            if (data.success) {
                const currentRow = data.data.find(item => item.id === rowData.id);
                setRowData(currentRow);
                setOriginalRowData(currentRow);
                successResponse();
                setRefreshTable(prev => !prev);
            } else {
                errorOccurred(data.error.message);
            }
        });
        setIsOpenEditDialog(false);
    };

    const getQR = () => {
        if (rowData.instanceState === "Не авторизован") {
            window.open(`https://qr.green-api.com/waInstance${rowData.instanceId}/${rowData.apiTokenInstance}`, '_blank');
        }
    };

    const filterQueueValue = (value) => value.replace(/[^a-zA-Z0-9._]/g, "");

    const handleChange = (prop) => (e) => {
        const value = e.target.value;

        setRowData(prev => ({
            ...prev,
            [prop]: prop === "queue" ? filterQueueValue(value) : value,
        }));
    };

    const handleChangeCreate = (prop) => (e) => {
        const value = e.target.value;

        setNewInstance(prev => ({
            ...prev,
            [prop]: prop === "queue" ? filterQueueValue(value) : value,
        }));
    };

    const isOpenCreateDialog = () => {
        setIsOpenCreate(!isOpenCreate);
    };

    const createInstance = () => {
        const payload = {
            host: newInstance.host ?? null,
            mediaHost: newInstance.mediaHost ?? null,
            phoneNumber: newInstance.phone ?? null,
            name: newInstance.name ?? null,
            queue: newInstance.queue ?? null,
            minPauseMessage: Number(newInstance.minPauseMessage) ?? null,
            maxPauseMessage: Number(newInstance.maxPauseMessage) ?? null,
            instanceId: newInstance.instanceId ?? null,
            apiTokenInstance: newInstance.apiTokenInstance ?? null,
        };

        createInstanceRequest(vendor, payload).then((data) => {
            if (data.success) {
                successResponse();
                setIsOpenCreate(false);
                setNewInstance(emptyNewInstance);
                setRefreshTable(prev => !prev);
            } else {
                errorOccurred(data.error.message);
            }
        });
    };

    const updateAllInstances = () => {
        updateAllInstancesStatus(vendor).then((data) => {
            if (data.success) {
                setRefreshTable(prev => !prev);
            } else {
                errorOccurred(data.error.message);
            }
        });
    };

    return {
        getTableData,
        refreshTable,

        isOpen,
        rowData,
        openMenuDialog,

        isOpenEditDialog,
        handleCloseEditDialog,
        handleChange,
        editInstance,

        updateStatus,
        restartInstance,
        logoutInstance,
        getQR,

        isOpenDeleteInstanceDialog,
        deleteInstanceDialog,
        deleteInstance,

        isOpenCreate,
        isOpenCreateDialog,
        newInstance,
        handleChangeCreate,
        createInstance,
        disableBtn,

        updateAllInstances,

        errorDialog,
        successDialog,
        errorMessage,
    };
}
